<template lang='pug'>
div(:class='$style[`cc-question-sub-reply`]')
  ul(v-if='subReplyData.length' :class='$style[`cc-question-sub-reply-ul`]')
    li(v-for='items, index in subReplyData' :key='index' :class='$style[`cc-question-sub-reply-li`]')
      QuestionSubReplyBrief(:subReplyBriefData='items')

  div(v-if='showLoadMore' :class='$style[`cc-question-sub-reply-load`]')
    span(@click='handleClickLoadSubReply')!= '更多回覆'


</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import QuestionSubReplyBrief from './QuestionSubReplyBrief';
// import { debounce } from 'debounce';
import {
  putQaSubReplyList,
} from '../../../js/restapi';

export default {
  components: {
    QuestionSubReplyBrief,
  },

  props: {
    qid: {
      type: String,
      default: '',
    },

    aaid: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      subReplyData: [],
      showLoadMore: true,
      pageIndex: 1,
      limitNum: 3,
    };
  },

  created() {
    this.axiosLoadSubReplyData(this.pageIndex);
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    axiosLoadSubReplyData(pageIndex) {
      const PASS_DATA = {
        size: `${this.limitNum}`,
        page: `${pageIndex}`,
        q_id: `${this.qid}`,
        aaid: `${this.aaid}`,
      };

      putQaSubReplyList('', PASS_DATA)
        .then((res) => {
          const subReplyRes = res.data;
          subReplyRes.results.map((x) => this.subReplyData.push(x));

          if (subReplyRes.length === 0) {
            console.log('SubReply 抓不到文章資料');
            // lazyState.complete();
            this.showLoadMore = false;
          } else if (subReplyRes.length < this.limitCount || this.subReplyData.length === subReplyRes.count) {
            console.log(`SubReply到底 ${this.pageIndex}`);
            this.showLoadMore = false;
          } else {
            console.log('SubReply還有');
          }
        })
        .catch((err) => {
          console.log('Axios putQaReplyList Error');
        });
    },

    handleClickLoadSubReply() {
      this.pageIndex = this.pageIndex + 1;
      console.log('this.pageIndex', this.pageIndex);
      this.axiosLoadSubReplyData(this.pageIndex);
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginStatus: 'user/exportLoginStatus',
      loginDjangoId: 'user/exportUserDjangoId',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/qa/questionSubReply.scss';
</style>
